import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import {toJS} from "mobx-react";
import Loading from "./Loading";
import PageNavigation from "./DynamicTable/PageNavigation";
import ItemsPerPage from "./DynamicTable/ItemsPerPage";
import Header from "./DynamicTable/Header";
import Body from "./DynamicTable/Body";
import ContextMenu from "./ContextMenu";
import UnlimitedFilter from "./UnlimitedFilter/UnlimitedFilter";
import Buttons from "./DynamicTable/Buttons";
import {StoreContext} from "../stores/contexts";

class DynamicTable extends Component {
  static contextType = StoreContext;

  componentDidMount() {
    if(!this.context.configStore.inited) {
      this.context.configStore.loadConfig();
    }
  }
  renderPageNav() {
    return (
      <div className="up12 margin unlimitedFilterNavigation">
        <div className="cell s-auto itemsPerPageWrap">
          <ItemsPerPage />
        </div>
        <div className="cell s-shrink pagesListWrap">
          <PageNavigation />
        </div>
      </div>
    );
  }
  render() {
    if(this.props.useExternalRenderMap) {
      if(!this.context.configStore.config.inited || this.context.configStore.config.fetching) {
        return this.props.children(false);
        // return false;
      }
      return this.props.children({
        data:this.context.dataStore.data,
        LeftButtons:<Buttons addClass={'mright10'} buttons={this.context.configStore.config.data.buttons_left} />,
        RightButtons:<Buttons addClass={'mleft10'} buttons={this.context.configStore.config.data.buttons_right} />,
        UnlimitedFilter:<UnlimitedFilter />,
        PageNav:this.renderPageNav(),
        Table: (
          <table>
            <Header />
            <Body externalRenderer={this.props.externalRenderer} />
          </table>
        ),
        ContextMenu:<ContextMenu />
      });
    }
    if(!this.context.configStore.config.inited || this.context.configStore.config.fetching) {
      return (
        <div>
          <Loading />
        </div>
      );
    }
    return (
      <div>
        <div className="pbottom20 up12 margin">
          <div className="cell s-auto">
            <Buttons addClass={'mright10'} buttons={this.context.configStore.config.data.buttons_left} />
          </div>
          <div className="cell s-auto tar">
            <Buttons addClass={'mleft10'} buttons={this.context.configStore.config.data.buttons_right} />
          </div>
        </div>
        <div className="pbottom20">
          <UnlimitedFilter />
        </div>
        <div className="pbottom10">
          {this.renderPageNav()}
        </div>
        <div className="pright40">
          <table>
            <Header />
            <Body externalRenderer={this.props.externalRenderer} />
          </table>
        </div>
        <div className="ptop10">
          {this.renderPageNav()}
        </div>
        <ContextMenu />
      </div>
    )
    /*
    return (
      <div>

        <div className="pbottom20 up12 margin">
          <div className="cell s-auto">
            <Buttons addClass={'mright10'} buttons={this.context.configStore.config.data.buttons_left} />
          </div>
          <div className="cell s-auto tar">
            <Buttons addClass={'mleft10'} buttons={this.context.configStore.config.data.buttons_right} />
          </div>
        </div>
        <div className="pbottom20">
          <UnlimitedFilter />
        </div>
        <div className="pbottom10">
          {this.renderPageNav()}
        </div>
        <div className="pright40">
          <table>
            <Header />
            <Body />
          </table>
        </div>
        <div className="ptop10">
          {this.renderPageNav()}
        </div>
        <ContextMenu />
      </div>
    )
     */
  }
}

// export default inject("configStore","dataStore")(observer(DynamicTable));
export default observer(DynamicTable);